import {
  factory as biLoggerFactory,
  Logger,
} from '@wix/fe-essentials-editor/bi';

const BI_PLATFORM_HOST_INTEGRATION_ENDPOINT = 'editor-platform';
const BI_PLATFORM_HOST_INTEGRATION_SRC = 164;
const PLATFORM_ERROR = 121;

export interface IPlatformBIOptions {
  metaSiteId: string;
  userId: string;
  editorSessionId: string;
  sdkVersion?: string;
  editorType?: string;
}

export const biEventSteps = {
  start: 'start',
  end: 'end',
  error: 'error',
};

export class BI {
  private biLogger: Logger;

  constructor(options: IPlatformBIOptions) {
    this.biLogger = this.createBILogger(options);
  }

  private createBILogger(options: IPlatformBIOptions) {
    return biLoggerFactory({
      endpoint: BI_PLATFORM_HOST_INTEGRATION_ENDPOINT,
    })
      .updateDefaults({
        src: BI_PLATFORM_HOST_INTEGRATION_SRC,
        msid: options.metaSiteId,
        uuid: options.userId,
        esi: options.editorSessionId,
        sdkVersion: options.sdkVersion,
        editorType: options.editorType,
      })
      .logger();
  }

  public createBiEvent(evid: number, event: Record<string, any>) {
    return {
      ...event,
      evid,
    };
  }

  public reportBi(event: Record<string, any>) {
    if (this.biLogger) {
      this.biLogger.log(event);
    }
  }

  public reportError(event: Record<string, any>) {
    this.reportBi(
      this.createBiEvent(PLATFORM_ERROR, {
        appDefinitionId: event.appDefId || event.appDefinitionId,
        pageType: event.appType || event.pageType,
        errorMessage: event.error.toString(),
        errorDetails: event.error.stack,
        name: event.error.name,
        errorType: event.error.name,
        errorCode: event.error.code,
      }),
    );
  }
}
